<template>
  <div
    class="modal modal-flex modal-flex-box fade"
    id="modal-scan-into-run"
    tabindex="-1"
    role="dialog"
    aria-labelledby="flexModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <validation-observer tag="div" ref="validation" class="modal-content" v-slot="{ validate }">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            &times;
          </button>
          <h4 class="modal-title" id="flexModalLabel">Add Garments onto run</h4>
        </div>
        <div class="modal-body">
          <div class="input-group">
            <span id="basic-addon1" class="input-group-addon">Garment Serial:</span>
            <input type="text" class="form-control" v-model="serial">
<!--            <span class="input-group-btn">-->
<!--              <button type="button" class="btn btn-block btn-success">Add Garment</button>-->
<!--            </span>-->
          </div>
          <hr>
          <div class="row">
            <div class="col-xs-6 col-sm-4">
              <div class="form-group">
                <label class="control-label">Show Station:</label>
                <multiselect
                  placeholder
                  preselect-first
                  :options="stations"
                  v-model="station"
                  :show-labels="false"
                />
              </div>
            </div>
            <div class="col-xs-6 col-sm-4">
              <div class="form-group"><label class="control-label">Sort By:</label>
                <multiselect
                  placeholder
                  preselect-first
                  :options="sortByOptions"
                  v-model="sort"
                  :show-labels="false"
                />
              </div>
            </div>
            <div class="col-xs-12 col-sm-4">
              <div class="form-group m-b-none">
                <div class="form-check checkbox checkbox-success m-t-sm-label">
                  <input
                    id="checkbox-hide-added"
                    type="checkbox"
                    class="styled"
                    v-model="hideAdded"
                  >
                  <label for="checkbox-hide-added">Hide added</label></div>
              </div>
            </div>
          </div>
        </div>
        <ul class="list-data has-multi-checkbox list-data-scan-onto-run list-data-overflow no-links has-button-right">
          <li class="data-heading hidden-xs sticky-top">
            <div class="row">
              <div class="col-sm-4">
                Firefighter
              </div>
              <div class="col-sm-2">
                ID
              </div>
              <div class="col-sm-3 col-md-4">
                Station
              </div>
              <div class="col-sm-3 col-md-2">
                Garments
              </div>
            </div>
          </li>
          <li v-for="(garments, firefighter, index) in groupedGarments" :key="firefighter">
            <div class="form-check checkbox checkbox-success">
              <input
                :id="`indeterminateCheckbox-${index}`"
                type="checkbox"
                class="styled"
                @click="scanAll($event, garments, index)"
              >
              <label :for="`indeterminateCheckbox-${index}`" />
            </div>
            <div
              class="row"
              data-toggle="collapse"
              :data-target="`#collapse-${index}`"
              aria-expanded="false"
              :aria-controls="`#collapse-${index}`"
              @click="toggleIcon(index)"
            >
              <div class="col-xs-6 col-sm-4">
                <p class="text-truncate">{{garments[0].firefighter}}</p>
              </div>
              <div class="col-xs-6 col-sm-2">
                <p class="text-truncate">{{garments[0].firefighter_id}}</p>
              </div>
              <div class="col-xs-6 col-sm-4"><p class="text-truncate text-muted">{{garments[0].station}}</p></div>
              <div class="col-xs-6 col-sm-3 col-md-2">
                {{ garments.length }}
              </div>
            </div>
            <button
              type="button"
              class="btn collapsed"
              data-toggle="collapse"
              :data-target="`#collapse-${index}`"
              aria-expanded="false"
              :aria-controls="`#collapse-${index}`"
              @click="toggleIcon(index)"
            >
              <font-awesome v-if="groupedButtons[index]" :id="`collapse-icon-${index}-plus`" :icon="['far', 'plus']"/>
              <font-awesome v-if="!groupedButtons[index]" :id="`collapse-icon-${index}-minus`" :icon="['far', 'minus']"/>
            </button>

            <ul :id="`collapse-${index}`" class="collapse garments">
              <li v-for="garment of garments" :key="garment.id">
                <div class="form-check checkbox checkbox-success">
                  <input :id="`checkbox-${garment.id}`" type="checkbox" class="styled" :checked="garment.added" @click="handleSelect(garment, garments, index)">
                  <label :for="`checkbox-${garment.id}`" />
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-5">
                    <p class="text-truncate">{{ garment.name }}</p>
                  </div>
                  <div class="col-xs-12 col-sm-7">
                    <p class="text-muted barcodes">
                      <span v-for="serial of garment.serial.split(',')" :key="serial">
                        <font-awesome :icon="['fas', 'barcode']"/> {{ serial }}
                      </span>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
        <div class="modal-footer">
          <button type="button" class="btn btn-green" data-dismiss="modal">
            Done
          </button>
        </div>
      </validation-observer>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import BaseModal from 'components/BaseModal'
import { mapState, mapActions } from 'vuex'
import { filter, map, uniq, sortBy, groupBy } from 'lodash'
import swal from 'sweetalert'
import $ from 'jquery'

export default {
  extends: BaseModal,

  props: ['id'],

  data () {
    return {
      serial: '',
      sort: 'Firefighter',
      sortByOptions: [
        'Firefighter',
        'Garment Type',
        'Fire Station'
      ],
      station: 'All',
      hideAdded: false,
      containerId: null,
      groupedButtons: []
    }
  },

  watch: {
    serial: {
      async handler () {
        if (this.serial.length === 10) {
          const garment = this.garments.find(item => item.serial.toLowerCase() === this.serial.toLowerCase())
          if (!garment) {
            swal({
              title: 'Garment Not Added',
              text: 'This garment\'s fire station is not on your run sheet',
              icon: 'warning',
              dangerMode: true
            })
          } else {
            if (garment.added) {
              swal({
                title: 'Garment Already Added',
                text: '',
                icon: 'warning',
                dangerMode: true
              })
            } else {
              await this.scanGarment(garment)
            }
          }
          this.serial = ''
        }
      }
    }
  },

  computed: {
    ...mapState('deliveryRuns/pendingGarments', ['garments']),

    stations () {
      return [
        'All',
        ...uniq(map(this.garments, 'station'))
      ]
    },

    filteredGarments () {
      let filters = {}
      if (this.hideAdded) {
        filters.added = false
      }

      if (this.station !== 'All') {
        filters.station = this.station
      }

      const list = filter(this.garments, filters)
      let sort
      switch (this.sort) {
        case 'Firefighter':
          sort = 'firefighter'
          break
        case 'Garment Type':
          sort = 'name'
          break
        case 'Fire Station':
          sort = 'station'
      }

      return sortBy(list, [sort])
        .map(garment => Object.assign({}, garment, {
          groupBy: `${garment.firefighter} - ${garment.station}`
        }))
    },

    groupedGarments () {
      return groupBy(this.filteredGarments, 'groupBy')
    }
  },

  methods: {
    ...mapActions('deliveryRuns/pendingGarments', ['getGarments', 'resetGarments', 'setSelected', 'remove', 'scan']),

    async onModalShow (event) {
      this.$refs.validation.reset()

      this.containerId = $(event.relatedTarget).data('container')

      this.resetGarments()
      await this.getGarments({ deliveryRunId: this.id })

      this.station = this.stations[1] ?? 'All'

      const keys = Object.keys(this.groupedGarments)
      this.groupedButtons = []
      for (let index = 0; index < keys.length; index++) {
        this.updateCheckboxState(this.groupedGarments[keys[index]], index)
        this.groupedButtons[index] = true
      }
    },

    onModalHidden () {
      this.serial = ''
      this.station = 'All'
      this.hideAdded = false
      this.groupedButtons = []
      this.containerId = null
      this.$emit('hidden')
    },

    scanGarment (item) {
      item.pending = true

      // GLOVE serial would be display as [SERIAL],[SERIAL]
      // we just need to grap the first one and
      // the backend would add the other for us
      const serial = item.serial.split(',')[0]

      const handleError = error => {
        let title = ''
        let message = ''

        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors.serial
          if (Array.isArray(errors) && errors[0]) {
            message = errors[0]
          }
        }

        if (item.added) {
          title = 'Garment Not Removed'
          this.setSelected({ garment: item.id, added: true })
        } else {
          title = 'Garment Not Added'
          this.setSelected({ garment: item.id, added: false })
        }

        swal({
          title: title,
          text: message,
          icon: 'warning',
          dangerMode: true
        })
      }

      if (item.added) {
        this.setSelected({ garment: item.id, added: false })

        return this.remove({ deliveryRunId: this.id, serial })
          .then(() => {
            this.$notify('success', 'Successfully removed garment.')
          })
          .catch(handleError)
          .finally(() => {
            item.pending = false
          })
      } else {
        this.setSelected({ garment: item.id, added: true })

        return this.scan({ deliveryRunId: this.id, serial, containerId: this.containerId })
          .then(() => {
            this.$notify('success', 'Successfully added garment.')
          })
          .catch(handleError)
          .finally(() => {
            item.pending = false
          })
      }
    },

    handleSelect (item, garments, index) {
      if (item.pending !== true) {
        this.scanGarment(item)
        this.updateCheckboxState(garments, index)
      }
    },

    updateCheckboxState (garments, index) {
      const selectedGarments = garments.filter(garment => garment.added).length
      const parentCheckbox = document.getElementById(`indeterminateCheckbox-${index}`)
      if (selectedGarments > 0) {
        if (selectedGarments !== garments.length) {
          // if this garment group is partially selected
          // change the parent checkbox to indeterminate
          parentCheckbox.indeterminate = true
        } else {
          // all garments selected
          parentCheckbox.checked = true
          parentCheckbox.indeterminate = false
        }
      } else {
        // all garments deselected
        parentCheckbox.checked = false
        parentCheckbox.indeterminate = false
      }
    },

    scanAll (event, garments, index) {
      let added
      if (event.target.checked) {
        added = false // remove all
      } else {
        added = true // add all
      }

      $(`#indeterminateCheckbox-${index}`).prop('disabled', true)
      this.$notify('info', 'Adding/removing multiple garments, please wait...')

      Promise.all(
        garments
          .filter(garment => garment.added === added)
          .filter(garment => !garment.pending)
          .map(this.scanGarment)
      ).finally(() => {
        $(`#indeterminateCheckbox-${index}`).prop('disabled', false)
      })
    },

    toggleIcon (index) {
      this.groupedButtons[index] = !this.groupedButtons[index]
      this.groupedButtons = [...this.groupedButtons] // trigger UI change instantly
    }
  }
}
</script>

<style scoped>
.checkbox input[type="checkbox"]:indeterminate + label::after,
.checkbox input[type="radio"]:indeterminate + label::after {
  display: block;
  content: "";
  width: 11px;
  height: 1.5px;
  background-color: #fff;
  border-radius: 2px;
  margin-left: -14.5px;
  margin-top: -1px !important;
  font-size: 10px;
}
</style>
